import axios from "axios";
import { requestReauth } from "@/lib/reauth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("ct_token");

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err?.config;
    if (err?.response?.status === 428 && cfg && !cfg._reauthed) {
      try {
        const tok = await requestReauth();
        cfg._reauthed = true;
        cfg.headers = { ...(cfg.headers || {}), "X-Reauth-Token": tok };
        return api(cfg);
      } catch (e) { return Promise.reject(err); }
    }
    if (err?.response?.status === 401 && !cfg?.url?.includes("/auth/reauth") && !cfg?.url?.includes("/auth/login")) {
      localStorage.removeItem("ct_token");
      localStorage.removeItem("ct_user");
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
};

export const REPORT_URL = (kind, params = "") =>
  `${API}/reports/${kind}?${params}${params ? "&" : ""}token=${getToken() || ""}`;
